import type { ChannelKeyName, ChannelMMX6Canonical } from "app/constants/MmxChannels";
import { assertExhaustiveCanonicalOrder, MMX_CHANNELS } from "app/constants/MmxChannels";

/**
 * Column/legend order for the segments GROUP marketing-channels views
 * (group table columns and group graph). Kept explicit because it intentionally
 * differs from the single-segment overview order; exhaustiveness is enforced at
 * compile time so a newly added channel cannot be silently dropped.
 */
const CHANNELS_OBJ_ORDER = assertExhaustiveCanonicalOrder([
    "Direct",
    "Mail",
    "OrganicSearch",
    "PaidSearch",
    "Referrals",
    "PaidReferrals",
    "OrganicSocial",
    "PaidSocial",
    "InternalReferrals",
    "GenAi",
    "Affiliates",
] as const);

/**
 * Canonical (PascalCase) → data key map, derived from {@link MMX_CHANNELS}.
 */
export const ChannelsObj = CHANNELS_OBJ_ORDER.reduce(
    (acc, canonical) => {
        const channel = MMX_CHANNELS.find((mmxChannel) => mmxChannel.canonical === canonical);
        if (!channel) {
            throw new Error(`Unknown MMX channel canonical: ${canonical}`);
        }
        acc[canonical] = channel.key;
        return acc;
    },
    {} as Record<ChannelMMX6Canonical, ChannelKeyName>,
);
